import { user_roles } from 'Data/Enum';
import PropTypes from 'prop-types';
import { createContext, useContext, useState } from 'react';
import { isUserAuthorized } from 'Util';
import { CURRENT_FISCAL_YEAR, OPEN_FISCAL_YEARS } from 'Util/dateUtil';

const GlobalContext = createContext(null);
GlobalContext.displayName = 'GlobalContext';

export const GlobalStateProvider = ({ children }) => {
  // Set fiscal year to current for 'Budgeter' users
  const [fiscalYear, setFiscalYear] = useState(
    isUserAuthorized({
      roles: [user_roles.BUDGETER],
    })
      ? new Date().getMonth() > 5 && new Date().getMonth() <= 6
        ? OPEN_FISCAL_YEARS
        : [`${CURRENT_FISCAL_YEAR}`]
      : null,
  );

  // Initial State
  const [globalState, setGlobalState] = useState(
    isUserAuthorized({
      roles: [user_roles.BUDGETER],
    })
      ? { fiscalYear }
      : {},
  );

  const updateGlobalState = (key, newValue) => {
    setGlobalState((oldState) => {
      if (!newValue) {
        const newState = { ...oldState };
        delete newState[key];
        return newState;
      } else if (oldState[key] !== newValue) {
        const newState = { ...oldState };
        newState[key] = newValue;
        return newState;
      } else {
        return oldState;
      }
    });
  };

  return (
    <GlobalContext.Provider
      value={[
        { ...globalState, fiscalYear },
        updateGlobalState,
        setFiscalYear,
      ]}>
      {children}
    </GlobalContext.Provider>
  );
};

GlobalStateProvider.propTypes = {
  children: PropTypes.node,
};

export const useGlobalState = () => useContext(GlobalContext);
